import styled from '@emotion/styled';
import Badge from '@mui/material/Badge';

export const MessageBadgeLeft = styled(Badge)({
  position: 'absolute',
  transform:'translate(-90%,-30%)',
  width: '32px',
  height: '22px',

  '> .MuiBadge-badge': {
    fontFamily: 'Avenir',
    fontWeight: '900',
  },
});

export const MessageBadgeRight = styled(Badge)({
  position: 'absolute',
  right: '23%',
  top: '21%',
  width: '32px',
  height: '22px',

  '> .MuiBadge-badge': {
    fontFamily: 'Avenir',
    fontWeight: '900',
  },
});
